module.exports = __webpack_public_path__ + "static/media/medium.1b6f5631.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/contact/medium.svg
// module id = 55
// module chunks = 0